<template>
  <v-dialog v-model="dialogs.object_picker" v-if="dialogs.object_picker" width="unset" :min-height="200" class="ma-0 pa-0" persistent>
    <picker-view />
  </v-dialog>
  <v-dialog v-model="dialogs.editor" v-if="dialogs.editor" width="unset" :min-height="200" class="ma-0 pa-0" persistent>
    <editor-view />
  </v-dialog>
  <v-dialog v-model="dialogs.date_picker" v-if="dialogs.date_picker" width="300" :min-height="200" class="ma-0 pa-0" persistent>
    <t-date-picker />
  </v-dialog>
  <v-dialog v-model="dialogs.yes_no" v-if="dialogs.yes_no" width="unset" :min-height="200" class="ma-0 pa-0" max-width="500px" persistent>
    <yes-no-dialog />
  </v-dialog>
  <v-dialog v-model="dialogs.input_dialog" v-if="dialogs.input_dialog" width="unset" :min-height="200" class="ma-0 pa-0" max-width="500px" persistent>
    <input-dialog />
  </v-dialog>
  <v-dialog v-model="dialogs.column_selector" v-if="dialogs.column_selector" :min-width="300" :max-width="400" :min-height="200" persistent width="auto">
    <grid-column-selector></grid-column-selector>
  </v-dialog>
  <v-dialog v-model="dialogs.google_map" v-if="dialogs.google_map" :min-width="500" :min-height="400" width="auto" persistent transition="nice-modal-fade">
    <google-map-view />
  </v-dialog>
  <message-box width="auto"></message-box>

  <!-- <v-dialog v-model="dialogs.loader" v-if="dialogs.loader" width="unset" :min-height="200" class="ma-0 pa-0" style="z-index: 999999" persistent> -->
  <modal-loading-component
    v-model:active="dialogs.loader"
    v-if="dialogs.loader"
    loader="dots"
    :background-color="isInDarkMode ? '#000' : '#FFF'"
    :color="isInDarkMode ? '#FFF' : '#000'"
    :opacity="0.88"
    :z-index="999998"
    style="z-index: 999998"
    :is-full-page="true"
  >
    <!-- <span slot:after>
    <br />
    {{ dialog.options && dialog.options.message ? dialog.options.message : msg }} 
  </span> -->
  </modal-loading-component>
  <!-- </v-dialog> -->
</template>
<script>
import GoogleMapView from "./GoogleMapView";
import MessageBox from "./MessageBox";
import PickerView from "./PickerView.vue";
import EditorView from "./EditorView.vue";
import TDatePicker from "./TDatePicker";
import YesNoDialog from "./YesNoDialog";
import GridColumnSelector from "./DataGridColumnSelector.vue";
import ModalLoadingComponent from "./ModalLoadingComponent";
import InputDialog from "./InputDialog.vue";
import "vue-loading-overlay/dist/css/index.css";
import { dialogs } from "./global_dialog";

export default {
  components: {
    GoogleMapView,
    GridColumnSelector,
    MessageBox,
    PickerView,
    EditorView,
    TDatePicker,
    YesNoDialog,
    InputDialog,
    ModalLoadingComponent,
  },
  data: () => ({
    dialogs: dialogs,
  }),
  computed: {},
  created() {},
  mounted() {},
  watch: {},
};
</script>